/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ServiceConfigVar = {
  properties: {
    pk: {
      type: "number",
      isReadOnly: true,
    },
    service: {
      type: "number",
      isRequired: true,
    },
    name: {
      type: "string",
      isRequired: true,
      maxLength: 100,
      minLength: 1,
    },
    value: {
      type: "string",
      isRequired: true,
      maxLength: 300,
      minLength: 1,
    },
    date_created: {
      type: "string",
      isReadOnly: true,
    },
    date_updated: {
      type: "string",
      isReadOnly: true,
    },
  },
};
